import { Route, Routes } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { AccessDenied, NotFound, SystemError } from '@/shared/components';

import {
  ChangePasswordPage,
  ForgotPasswordPage,
} from '../../authentication/components';
import ResetPasswordPage from '../../authentication/components/ResetPasswordPage';
import SignInPage from '../../authentication/components/SignInPage';
import { ClipLibraryPage, ClipsPage } from '../../clips/components';
import { GamePage, GamesPage } from '../../games/components';
import AuthenticateRoute from './AuthenticateRoute';
import LandingRedirect from './LandingRedirect';
import { OrganizationSettingsPage, AccountSettingsPage, ClipDispatchPage, ClipRulesPage } from '../../settings/components';
import ManageGames from '@/features/settings/components/ManageGames';
import { GroupManagement } from '@/features/GroupManagement';
import ApiKeyManagementPage from '@/features/apiKey/components/ApiKeyManagementPage';
import McpPage from '@/features/mcp/components/McpPage';
import McpAuthorizePage from '@/features/mcp/components/McpAuthorizePage';
import ManageSessionsPage from '@/features/session/components/ManageSessionsPage';
import ManageDepartments from '@/features/department/components/ManageDepartments';
import ManageInstancePlanning from '@/features/org/components/ManageInstancePlanning';
import ManageQueue from '@/features/settings/components/ManageQueue';
import ManageConfigs from '@/features/settings/components/ManageConfigs';
import ManageCronJobs from '@/features/settings/components/ManageCronJobs';
import AuditLogs from '@/features/settings/components/AuditLogs';
import ManageTranscodingProfiles from '@/features/settings/components/ManageTranscodingProfiles';
import OrgManagementPage from '@/features/org/components/OrgManagementPage';
import WscStreamsPage from '@/features/wsc-streams/components/WscStreamsPage';
import ResourcesPage from '@/features/kirby-resources/components/ResourcesPage';
import SimulivePage from '@/features/kirby-resources/components/SimulivePage';

export default () => {
  const { clipLibrary, enableSimuliveAndTestLab } = useFlags();

  return (
  <Routes>
    <Route
      path="/org-management"
      element={
        <AuthenticateRoute>
          <OrgManagementPage />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/manage-users"
      element={
        <AuthenticateRoute>
          <OrganizationSettingsPage />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/account-settings"
      element={
        <AuthenticateRoute>
          <AccountSettingsPage />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/"
      element={
        <AuthenticateRoute>
          <LandingRedirect />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/games/:gameId"
      element={
        <AuthenticateRoute>
          <GamePage />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/games"
      element={
        <AuthenticateRoute>
          <GamesPage />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/clips"
      element={
        <AuthenticateRoute>
          <ClipsPage />
        </AuthenticateRoute>
      }
    />
    {clipLibrary && (
      <Route
        path="/clip-library"
        element={
          <AuthenticateRoute>
            <ClipLibraryPage />
          </AuthenticateRoute>
        }
      />
    )}
    <Route
      path="/streams"
      element={
        <AuthenticateRoute>
          <WscStreamsPage />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/resources"
      element={
        <AuthenticateRoute>
          <ResourcesPage />
        </AuthenticateRoute>
      }
    />
    {enableSimuliveAndTestLab && (
      <Route
        path="/simulive"
        element={
          <AuthenticateRoute>
            <SimulivePage />
          </AuthenticateRoute>
        }
      />
    )}
    <Route
      path="/manage-departments"
      element={
        <AuthenticateRoute>
          <ManageDepartments />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/manage-games"
      element={
        <AuthenticateRoute>
          <ManageGames />
        </AuthenticateRoute>
      }
    />
      <Route
      path="/automated-clipping"
      element={
        <AuthenticateRoute>
          <ClipRulesPage />
        </AuthenticateRoute>
      }
    />
      <Route
      path="/manage-q"
      element={
        <AuthenticateRoute>
          <ManageQueue />
        </AuthenticateRoute>
      }
    />
      <Route
      path="/manage-crons"
      element={
        <AuthenticateRoute>
          <ManageCronJobs />
        </AuthenticateRoute>
      }
    />
      <Route
      path="/manage-configs"
      element={
        <AuthenticateRoute>
          <ManageConfigs />
        </AuthenticateRoute>
      }
    />
      <Route
      path="/audit-logs"
      element={
        <AuthenticateRoute>
          <AuditLogs />
        </AuthenticateRoute>
      }
    />
      <Route
      path="/transcoding-profiles"
      element={
        <AuthenticateRoute>
          <ManageTranscodingProfiles />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/manage-groups"
      element={
        <AuthenticateRoute>
          <GroupManagement />
        </AuthenticateRoute>
      }
    />
      <Route
      path="/api-key"
      element={
        <AuthenticateRoute>
          <ApiKeyManagementPage />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/mcp"
      element={
        <AuthenticateRoute>
          <McpPage />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/mcp/authorize"
      element={
        <AuthenticateRoute>
          <McpAuthorizePage />
        </AuthenticateRoute>
      }
    />
    <Route
      path="/instances-scheduler"
      element={
        <AuthenticateRoute>
          <ManageInstancePlanning />
        </AuthenticateRoute>
      }
    />

        <Route
      path="/manage-sessions"
      element={
        <AuthenticateRoute>
          <ManageSessionsPage />
        </AuthenticateRoute>
      }
    />
    
    <Route
      path="/clip-dispatch"
      element={
        <AuthenticateRoute>
          <ClipDispatchPage />
        </AuthenticateRoute>
      }
    />
    <Route path="/sign-in" element={<SignInPage />} />
    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/change-password" element={<ChangePasswordPage />} />
    <Route path="/access-denied" element={<AccessDenied />} />
    <Route path="/system-error" element={<SystemError />} />

    {/* Catch-all 404 route */}
    <Route path="*" element={<NotFound />} />
  </Routes>
  );
};
